module.exports = __webpack_public_path__ + "static/media/background.1d564889.svg";